module.exports = __webpack_public_path__ + "assets/img/copy.c8d74599.svg";